import { useEventBus } from '@vueuse/core'
const LAYOUT_PROVIDER_KEY = Symbol('layout-provider-key')

export enum LayoutEventTypes {
  GO_HOME,
}
interface EventBusArg {
  type: LayoutEventTypes
  payload?: object
}
export const layoutEventBus = useEventBus<EventBusArg>(LAYOUT_PROVIDER_KEY)
